module.exports = __webpack_public_path__ + "static/header-life-7eed019404d085c6c8093c49fcefb8cc.jpg";